<template>
    <div class="cz3__gallery__images" v-auto-animate>
        <button v-for="image in images" :key="image.url"
            :class="[
                'cz3__gallery__image',
                {
                    'cz3__gallery__image--selected': image === selectedGalleryImage,
                }
            ]"
            :title="image.name"
            @click.prevent="selectGalleryImage(image)"
        >
            <span class="cz3__gallery__image__image" :data-url="image.url"
                :style="{
                    backgroundImage: makeImageUrl(image.url)
                }"
            ></span>
        </button>

        <button v-if="!expanded && hasMore" class="cz3__gallery__view-more" @click.prevent="expand">
            <span>{{$t('V3_VIEW_MORE')}}</span>
        </button>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__gallery__view-more {
            position: relative;

            width: 73px;
            height: 73px;

            border-radius: 8px;

            border: none;
            background: transparent;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            display: flex;
            justify-content: center;
            align-items: center;

            span {
                font-family: $font-main;
                font-weight: 400;
                font-size: 12px;

                text-decoration: underline;
                text-underline-offset: 1px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            group: Array,
            maxItems: Number,
            selectedGalleryImage: Object,
        },

        data() {
            return {
                expanded: false,
            };
        },

        computed: {
            images() {
                if (this.expanded) {
                    return this.group;
                }

                return this.group.slice(0, this.maxItems);
            },

            hasMore() {
                return this.group.length > this.maxItems;
            },
        },

        methods: {
            expand() {
                this.expanded = true;
            },

            selectGalleryImage(image) {
                this.$emit('selectGalleryImage', image);
            },

            makeImageUrl(u) {
                return `url("${u}")`;
            },
        },
    };
</script>
